import type { ProgressProps as MantineProgressProps, ProgressRootProps } from '@mantine/core';
import { Progress } from '@mantine/core';

import classes from './Progress.module.css';

const ProgressDefaultProps: Partial<MantineProgressProps> = {
  radius: '100px',
};

const ProgressDefaults = Progress.extend({
  defaultProps: ProgressDefaultProps,
  classNames: {
    root: classes.root,
    section: classes.section,
  },
});

const ProgressSectionDefaults = Progress.Section.extend({
  defaultProps: {
    color: 'mint',
  },
});

export { Progress, ProgressDefaults, ProgressRootProps, ProgressSectionDefaults };
